// DOCUMENTATION https://craftyclicks.co.uk/docs/global/javascript.html#basic-configuration-options

var TrilliumLookupsCraftyClicks = (function ($) {

    var IsAutoFillTriggered = false;
    var CountriesWithoutPostCode = [];
    var bindAddressLookups = function () {

        var addressLookUpToken = jQuery('#craftyClicksAccessToken');
        var addressLookUps = jQuery('form.form-postcodelookup:not(.ccBound)');
        if (!CountriesWithoutPostCode.length > 0) {
            $.getJSON(`/umbraco/api/CrmAddressapi/getcountrieswithoutpostcode`).done((data) => {
                if (data?.Result?.length > 0) {
                    CountriesWithoutPostCode = data.Result;
                    console.log(data.Result);
                }
            })
        }

        $(document).ready(function () {
            var array = $(".match-height");
            var height = 0;
            for (i = 0; i < array.length; i++) {
                if ($(array[i]).height() > height) {
                    height = $(array[i]).height();
                }
            }
            $(array).height(height);
        })

        if (addressLookUpToken !== undefined &&
            addressLookUpToken !== null &&
            addressLookUpToken.val() !== null &&
            addressLookUps !== undefined &&
            addressLookUps !== null &&
            addressLookUps.length > 0) {

            var cc_object = window.cc_object;
            if (cc_object === undefined ||
                cc_object === null) {
                cc_object = new clickToAddress({
                    accessToken: addressLookUpToken.val(),
                    domMode: 'id',
                    placeholders: false,
                    texts: {
                        default_placeholder: ''
                    },
                    onResultSelected: function (c2a, elements, address) {
                        IsAutoFillTriggered = true;
                        var countryIso = address.country.iso_3166_1_alpha_3;
                        var orginalPostCoderef = $("#PostCodeLabelRef").val();
                        $("#HomeAddressForReview").val("False");
                        //Tag generated using MaxLength data anotation only
                        var optionalPostBox = '<input autocomplete="PCATEST" class="form-control text-box single-line postcodelookup-postcode text-box single-line" data-val="true" data-val-maxlength="Max length 16 characters" data-val-maxlength-max="16" id="OptionalPostCode" name="OptionalPostCode" placeholder="Postcode" type="text" value="" readonly/>'
                        //Tag generated from BaseAddressFormViewModel -> PostCode
                        var requiredPostBox = `<input autocomplete="PCATEST" class="form-control text-box single-line postcodelookup-postcode text-box single-line" data-val="true" data-val-maxlength="Max length 16 characters" data-val-maxlength-max="16" data-val-required="Please enter your postcode" data-val-specialcharacterregex="Invalid characters" data-val-specialcharacterregex-pattern="^[^$£&amp;~+:=?[\]\\@#|{}&quot;<>.;^*%!\/]+$" id="PostalCode" name="PostalCode" placeholder="Postcode" type="text" value="${address?.postal_code}" readonly/>`;

                        //make postcode optional for Countries without postcode vice versa
                        if (address?.postal_code == null || address?.postal_code == "") {
                            $("[for=PostalCode]")[0].innerHTML = "Postcode";
                            $(".postcodelookup-postcode").replaceWith(optionalPostBox);
                        } else {
                            $("[for=PostalCode]")[0].innerHTML = `${orginalPostCoderef} (required)`;
                            $(".postcodelookup-postcode").replaceWith(requiredPostBox);
                        }

                        var selectVal = $(".postcodelookup-country").val(countryIso);
                        if ($(".postcodelookup-country").hasClass("select2-hidden-accessible")) {
                            $(".postcodelookup-country").trigger('change.select2');
                            if ($(".hidden-country").length) {
                                $(".hidden-country").val(selectVal.val());
                            }
                        }
                        if ($(".form-group").hasClass("has-error")) {
                            // clear any previous error
                            $(this).removeClass("has-error");
                        }

                        $("[class*=postcodelookup-addr_line_]").each(function () {
                            $(this).attr("readonly", false);
                        });

                        if ($("[class*=postcodelookup-addr_line_3]").length > 0) {
                            $("[class*=postcodelookup-addr_line_3]").val(address.line_3);
                        }

                        var organisationReadOnly = $(".postcodelookup-company_name").val() !== "";
                        var townReadOnly = $(".postcodelookup-town").val() !== "";
                        var countyReadOnly = $(".postcodelookup-county").val() !== "";
                        var countryReadOnly = $(".postcodelookup-town").val() !== "";

                        $(".postcodelookup-company_name").attr("readonly", organisationReadOnly);
                        $(".postcodelookup-town").attr("readonly", townReadOnly);
                        $(".postcodelookup-county").attr("readonly", countyReadOnly);
                        $(".postcodelookup-country").attr("readonly", countryReadOnly);

                        if (!$(".address-editbtn").is(":visible")) {
                            $(".address-editbtn").toggle();
                        }
                    }
                });
                window.cc_object = cc_object;
            }

            if (cc_object !== undefined &&
                cc_object !== null) {

                addressLookUps.each(function () {

                    $(this).addClass('ccBound');

                    var id_SearchField = "";
                    if ($(this).find('.postcodelookup-search') !== undefined) {
                        id_SearchField = $(this).find('.postcodelookup-search').attr('id');
                    }

                    var id_TownField = "";
                    if ($(this).find('.postcodelookup-town') !== undefined) {
                        id_TownField = $(this).find('.postcodelookup-town').attr('id');
                    }

                    var id_CountyField = "";
                    if ($(this).find('.postcodelookup-county') !== undefined) {
                        id_CountyField = $(this).find('.postcodelookup-county').attr('id');
                    }

                    var id_PostCode = "";
                    if ($(this).find('.postcodelookup-postcode') !== undefined) {
                        id_PostCode = $(this).find('.postcodelookup-postcode').attr('id');
                    }

                    var id_CountryField = "";
                    if ($(this).find('.postcodelookup-country') !== undefined) {
                        id_CountryField = $(this).find('.postcodelookup-country').attr('id');
                    }

                    var id_AddressLine1Field = "";
                    if ($(this).find('.postcodelookup-addr_line_1') !== undefined) {
                        id_AddressLine1Field = $(this).find('.postcodelookup-addr_line_1').attr('id');
                    }

                    var id_AddressLine2Field = "";
                    if ($(this).find('.postcodelookup-addr_line_2') !== undefined) {
                        id_AddressLine2Field = $(this).find('.postcodelookup-addr_line_2').attr('id');
                    }

                    var id_AddressLine3Field = "";
                    if ($(this).find('.postcodelookup-addr_line_3') !== undefined) {
                        id_AddressLine3Field = $(this).find('.postcodelookup-addr_line_3').attr('id');
                    }

                    var id_CompanyName = "";
                    if ($(this).find('.postcodelookup-company_name') !== undefined) {
                        id_CompanyName = $(this).find('.postcodelookup-company_name').attr('id');
                    }

                    try {
                        cc_object.attach({
                            search: id_SearchField,
                            town: id_TownField,
                            country: id_CountryField,
                            county: id_CountyField,
                            line_1: id_AddressLine1Field,
                            line_2: id_AddressLine2Field,
                            line_3: id_AddressLine3Field,
                            postcode: id_PostCode,
                            company: id_CompanyName
                        });
                    }
                    catch (err) {
                        console.log(err);
                    }

                });
            }
        }

        $("#select2-Country-container").on('DOMSubtreeModified', function (e) {
            if (!IsAutoFillTriggered) {
                setTimeout(function () {
                    var orginalPostCoderef = $("#PostCodeLabelRef").val();
                    var selectedCountry = $("#select2-Country-container")[0].title;
                    //Tag generated using MaxLength data anotation only
                    var optionalPostBox = '<input autocomplete="PCATEST" class="form-control text-box single-line postcodelookup-postcode text-box single-line" data-val="true" data-val-maxlength="Max length 16 characters" data-val-maxlength-max="16" id="OptionalPostCode" name="OptionalPostCode" placeholder="Postcode" type="text" value="" readonly>'
                    //Tag generated from BaseAddressFormViewModel -> PostCode
                    var requiredPostBox = `<input autocomplete="PCATEST" class="form-control text-box single-line postcodelookup-postcode text-box single-line" data-val="true" data-val-maxlength="Max length 16 characters" data-val-maxlength-max="16" data-val-required="Please enter your postcode" data-val-specialcharacterregex="Invalid characters" data-val-specialcharacterregex-pattern="^[^$£&amp;~+:=?[\]\\@#|{}&quot;<>.;^*%!\/]+$" id="PostalCode" name="PostalCode" placeholder="Postcode" type="text" value="">`;

                    if (selectedCountry != null || selectedCountry != undefined) {
                        var countryWithoutpost = CountriesWithoutPostCode.filter(c => c.Name != "" && c.Name.toLowerCase() == selectedCountry.toLowerCase())
                        //get list and check with selectedCountry
                        var postcodeId = $(".postcodelookup-postcode").attr("id");
                        if (countryWithoutpost?.length > 0) {
                            IsPostCode = false;
                            $("[for=PostalCode]")[0].innerHTML = "Postcode";
                            $(".postcodelookup-postcode").replaceWith(optionalPostBox);
                        } else {
                            if (postcodeId != "PostalCode") {
                                $("[for=PostalCode]")[0].innerHTML = `${orginalPostCoderef} (required)`;
                                $(".postcodelookup-postcode").replaceWith(requiredPostBox);
                            }
                            IsPostCode = true;
                        }
                    }
                }, 100)
            } else {
                setTimeout(function () {
                    IsAutoFillTriggered = false;
                }, 1000)
                e.preventDefault();
                return false;
            }
            
        })
    };
    return {
        init: function () {
            bindAddressLookups();
        }
    };

})(window.jQuery);
$(function () {
    TrilliumLookupsCraftyClicks.init();
});

window.TrilliumLookupsCraftyClicks = TrilliumLookupsCraftyClicks;
